import React from "react";
import styled from "@emotion/styled";
import EditorAddIcon from "@atlaskit/icon/glyph/editor/add";

import { Button } from "../../UI/Button";
import { EnhancedTable } from "../EnhancedTable";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import { QUESTIONS_LIMIT } from "../../constants/general";
import { Grid } from "../../UI/Grid";

import { FreeTextQuestionsTableHead } from "./FreeTextQuestionsTableHead";
import { FreeTextQuestionsTableBody } from "./FreeTextQuestionsTableBody";
import { FreeTextQuestionModal } from "../FreeTextQuestionModal";
import useAuth from "../../routes/login/AuthContext";

export interface IProps {
  questions: any[];
  onReorder: (data: any) => void;
  onSave: (data: any) => void;
  onRemove: (data: any) => void;
  showTagColumn?: any;
  editDisabled: boolean;
}

const StyledAddButton = styled(Button)`
  height: 40px;
`;

export const FreeTextQuestionsTable: React.FC<IProps> = (props) => {
  const { isSuperAdminRead } = useAuth();
  const [data, setData] = React.useState<Record<string, any> | boolean>(false);

  const openQuestionHandler = () => setData(true);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <EnhancedTable title="Open Text Questions">
            <FreeTextQuestionsTableHead showTagColumn={props.showTagColumn} />
            <FreeTextQuestionsTableBody setData={setData} {...props} />
          </EnhancedTable>
        </Grid>
        {props.questions.length <= QUESTIONS_LIMIT && (
          <Grid item xs={12}>
            <ReadOnlyWrapper>
              <StyledAddButton
                isDisabled={isSuperAdminRead() || props.editDisabled}
                appearance="primary"
                iconBefore={<EditorAddIcon label="Plus" />}
                onClick={openQuestionHandler}
              >
                Add an Open Text Question
              </StyledAddButton>
            </ReadOnlyWrapper>
          </Grid>
        )}
      </Grid>
      <FreeTextQuestionModal data={data} onHide={setData} onSave={props.onSave} showTagColumn={props.showTagColumn} />
    </>
  );
};
